module.exports = __webpack_public_path__ + "img/cwell4.9c6bffbd.jpg";